import React from "react";
// import resume from "./Jennifer_Kramer_Web_Developer_Resume.pdf";

const Resume = () => {
  return (
    <div id="resume" className="resume">
      <div className="d-flex justify-content-center my-5">
        <h1 className="resume-title">Resume</h1>
      </div>
      <div className="text-center margin-download">
        {/* <a className="btn-main-offer dark-blue-btn" href={resume} download>
                    Download
                </a> */}
      </div>
      <div className="container timeline-wrapper">
        {/* <div className="timeline-block timeline-block-left">
          <div className="timeline-content">
            <h2>Feb. 2020 - Current</h2>
            <h3>LLC - Owner | Manager</h3>
            <ul className="remove-margin-bottom">
              <li>
                Created a Limited Liability Corporation resulting in over 100
                sales
              </li>
              <li>
                Designed website, including logo, color selections, and product
                photography
              </li>
              <li>
                Listed products on popular handcraft shop websites to funnel
                leads to main website
              </li>
            </ul>
          </div>
        </div> */}
        <div className="timeline-block timeline-block-right">
          <div className="timeline-content">
            <h2>Sept. 2020 - May 2021</h2>
            <h3>Full-Stack Web Development - Lambda School</h3>
            <ul className="remove-margin-bottom">
              <li>
                9 month intensive coding bootcamp that focuses on full-stack web
                development and computer science
              </li>
              <li>
                Planned, coded, and designed application components
                independently
              </li>
              <li>
                Worked with front-end and back-end teams of varying levels to
                create working applications within either a week to a month span
              </li>
            </ul>
          </div>
        </div>
        <div className="timeline-block timeline-block-left">
          <div className="timeline-content">
            <h2>Aug. 2017 - Sept. 2019</h2>
            <h3>Graphic Designer - Night Owl SP, LLC</h3>
            <ul className="remove-margin-bottom">
              <li>
                Designed and updated quick setup guides and manuals of security
                products using Illustrator and InDesign
              </li>
              <li>
                Photographed and edited security product photos for print and
                web purposes within a span of one week
              </li>
              <li>
                Developed line art to demonstrate setup of products utilizing
                Illustrator within one day
              </li>
            </ul>
          </div>
        </div>
        <div className="timeline-block timeline-block-right">
          <div className="timeline-content">
            <h2>Jan. 2016 - July 2017</h2>
            <h3>Photo Editor - ibidesigns, INC</h3>
            <ul className="remove-margin-bottom">
              <li>
                Combined multiple photo stills of luxurious, residential real
                estate for marketing purposes in digital and print format
              </li>
              <li>
                Corrected any imperfections that were in the photographs such as
                removing telephone poles, patches of brown grass, reflections of
                camera equipment and photographer, and unnecessary items using
                Photoshop
              </li>
              <li>
                Vectorized uneditable files to have the ability of manipulation,
                i.e. have ability to change font color of a logo
              </li>
            </ul>
          </div>
        </div>
        <div className="timeline-block timeline-block-left">
          <div className="timeline-content">
            <h2>Jan. 2015 - Jan. 2016</h2>
            <h3>Freelance Graphic Designer - DFS Graphics</h3>
            <ul className="remove-margin-bottom">
              <li>
                Created digital files for either to print directly in shop,
                print through a third party vendor, or to be used for web
                purposes
              </li>
              <li>
                Collaborated with an in-house party planning company and
                assisted in creating materials needed for special occasions
              </li>
              <li>
                Produced design files for various marketing materials including
                but not limited to business cards, logos, for-sale signs,
                vehicle wraps, brochures, invitations, flyers, banners, stage
                backdrops, coasters, stickers, folder inserts, display signs,
                window and floor decals, etc.
              </li>
            </ul>
          </div>
        </div>
        <div className="timeline-block timeline-block-right">
          <div className="timeline-content">
            <h2>Aug. 2014 - Jan. 2015</h2>
            <h3>
              Graphic Artist / Marketing Assistant - Magnum Management Services,
              LLC | Magnum Realty Services, LLC
            </h3>
            <ul className="remove-margin-bottom">
              <li>
                Created flyers of commercial, agricultural, and residential
                properties for sale
              </li>
              <li>
                Researched property comparables to obtain knowledge of current
                price range of property by type, square footage, built year, and
                location
              </li>
              <li>
                Communicated with on-site property manager and third-party
                members, such as photographers and videographers, to obtain
                marketing photos and videos for the sale of properties
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
